export default __webpack_public_path__ + "static/image-site-build-727f11f8260a057a31c6b323e51e8346.png";